import { NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  EditGanttSettings,
  GetGanttSettings,
} from '../../../services/CloudScheduler/CloudSchedulerServices';
import { useEffect, useState } from 'react';
import Message from '../../../utils/Message/Message';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

const SupervisorControlModuleSettings = () => {
  const [maxSchedulerPeriod, setMaxSchedulerPeriod] = useState<any>();
  const [currentSettingsId, setCurrentSettingsId] = useState(-1);
  const onChange = (args: any) => {
    setMaxSchedulerPeriod(args.value);
  };
  const savePoint = () => {
    let objGant = {
      component_type: 'supervisor-control',
      settings_name: 'max-scheduler-period',
      content: '',
      value: maxSchedulerPeriod.toString(),
      id: currentSettingsId,
    };
    saveGanttSettings(objGant);
  };
  const saveGanttSettings = (obj: any) => {
    EditGanttSettings(obj)
      .then((err) => {
        Message.success('Success..');
        if (currentSettingsId === -1) {
          getGanttSettings('supervisor-control$max-scheduler-period');
        }
      })
      .catch((err) => {
        Message.error('Error occured while saving settings');
      });
  };
  const getGanttSettings = (query: string) => {
    GetGanttSettings(query).then((res) => {
      if (res.data[0]) {
        let value = JSON.parse(res.data[0]?.value);
        setCurrentSettingsId(res?.data[0]?.id);
        if (!isNaN(value)) {
          setMaxSchedulerPeriod(value);
        }
      }
    });
  };
  useEffect(() => {
    getGanttSettings('supervisor-control$max-scheduler-period');
  }, []);
  return (
    <div>
      <div style={{
        display:"flex",
        position:"absolute",
        right:0
      }}>
        <ButtonComponent
          isPrimary
          style={{ width: '150px', marginTop: 5 }}
          onClick={savePoint}
        >
          Save
        </ButtonComponent>
      </div>
      <div className='row' style={{ padding: 50 }}>
        <div className='col-md-12'>
          <div className='col-md-6'>
            <span style={{fontFamily:"serif",textTransform:"uppercase",marginBottom:2}}>Supervisor Control Hub Settings</span>
          </div>
          <div className='col-md-6'></div>
        </div>
        <div className='col-md-6'>
          <div className='col-md-6'></div>
          <div className='col-md-6'></div>
        </div>
        <table
          id='property'
          className='property-panel-table table'
          title='Properties'
          style={{ width: '100%', color: 'white', backgroundColor: 'black' }}
        >
          <tbody>
            <tr>
              <td style={{ width: '30%' }}>
                <span>Max Scheduler Period</span>
              </td>
              <td style={{ width: '70%' }}>
                <div>
                  <NumericTextBoxComponent
                    value={maxSchedulerPeriod}
                    min={0}
                    max={700}
                    showSpinButton={true}
                    width='150px'
                    step={1}
                    change={onChange.bind(this)}
                  />
                </div>
              </td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SupervisorControlModuleSettings;
